import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { CreateChannelMembershipResponseFilterSensitiveLog, } from "../models/models_0";
import { de_CreateChannelMembershipCommand, se_CreateChannelMembershipCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class CreateChannelMembershipCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "CreateChannelMembership", {})
    .n("ChimeSDKMessagingClient", "CreateChannelMembershipCommand")
    .f(void 0, CreateChannelMembershipResponseFilterSensitiveLog)
    .ser(se_CreateChannelMembershipCommand)
    .de(de_CreateChannelMembershipCommand)
    .build() {
}
